var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("datatable", {
        attrs: {
          data: _vm.tableData,
          columns: _vm.headers,
          actions: _vm.actions,
          index: false,
          itemsPerPage: "6"
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.shareDialog,
            callback: function($$v) {
              _vm.shareDialog = $$v
            },
            expression: "shareDialog"
          }
        },
        [
          _c("share-asset-card", {
            attrs: { asset: _vm.assetItem, assetType: _vm.asset_type },
            on: { close: _vm.closeShare }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-648bc02c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648bc02c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/assetTable.vue
// module id = null
// module chunks = 